var TASK_ITEM_STATUS;
(function (TASK_ITEM_STATUS) {
    TASK_ITEM_STATUS["COMPLETED"] = "Completed";
    TASK_ITEM_STATUS["PENDING_NORMAL"] = "Pending_Normal";
    TASK_ITEM_STATUS["PENDING_URGENT"] = "Pending_Urgent";
    TASK_ITEM_STATUS["BLOCKED"] = "Blocked";
})(TASK_ITEM_STATUS || (TASK_ITEM_STATUS = {}));
export default TASK_ITEM_STATUS;
//# sourceMappingURL=task-item-status.js.map